import React from 'react';
import { DatePicker, ConfigProvider } from 'antd';
import { SelectedTheme, RedTheme } from 'common/global';
import { ReactComponent as JNJCalendarIcon } from 'common/assets/images/Calender.svg';
import { useScreen } from 'common/hooks/useScreen';

export const SingleDatePicker = ({
  onChange,
  defaultValue,
  value,
  width = '0px',
  height,
  marginTop,
  padding,
  ...rest
}) => {
  const screen = useScreen();
  const theme = SelectedTheme();
  let redtheme = RedTheme;

  const handleDateChange = (date, dateString) => {
    if (onChange) onChange(date, dateString);
  };

  const getCustomPopupContainer = () =>
    document.getElementById('custom-popup-container');

  const customStyle = {
    ...(!screen.isTablet ? { width: width !== '0px' ? width : '400px' } : {}),
    height: height || '40px',
    borderRadius: '1px',
    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottom: `2px solid ${redtheme.palette.dateRangePicker.gray_orange}`,
    marginTop: marginTop,
    padding: padding || '4px 11px 4px',
    fontFamily: '"JohnsonText-Light"',
    fontWeight: screen.isMobile && 400,
    fontSize: screen.isDesktop ? '16px' : '14px',
    lineHeight: screen.isDesktop ? '24px' : '16px',
  };

  const popupStyle = {
    position: 'absolute',
    zIndex: 9999,
  };

  return (
    <div>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: `${theme.palette.primary.main}`,
            fontFamily: '"JohnsonText-Light"',
            fontSize: '16px',
            lineHeight: '16px',
            fontWeight: 400,
            colorTextPlaceholder: theme.palette.text.lightCaption,
            colorIcon: '0,0,0,0.88',
            paddigXXS: '0px',
            borderRadius: '16px',
          },
        }}
      >
        <div id="custom-popup-container"></div>
        <DatePicker
          {...rest}
          onChange={handleDateChange}
          getPopupContainer={getCustomPopupContainer}
          style={customStyle}
          placeholder="dd-mmm-yyyy"
          popupStyle={popupStyle}
          format="DD-MMM-YYYY"
          suffixIcon={<JNJCalendarIcon height="14" width="14" />}
          defaultValue={defaultValue}
          value={value}
          allowClear
        />
      </ConfigProvider>
    </div>
  );
};
